import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useParams, useNavigate } from "react-router-dom"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import { fetchPvsDetails, getPvsDetails } from "../../../redux/actions/pvs"

const InfoRow = ({ label, value }) => (
  <div className="mb-2 d-flex">
    <strong style={{ minWidth: "160px" }}>{label}</strong>
    <span style={{ width: "20px" }}>:</span>
    <span>{value || "-"}</span>
  </div>
)

const SectionCard = ({ icon, title, children }) => (
  <Card className="pula-profile-card mb-4">
    <CardBody>
      <div className="pula-card-header mb-3">
        <div className="pula-card-title">
          <i className={`${icon} me-2`} style={{ fontSize: "18px" }}></i>
          <span>{title}</span>
        </div>
      </div>
      {children}
    </CardBody>
  </Card>
)

const ViewPvsDetails = () => {
  document.title = "PVS Details"

  const { enc_pvs_entry_id } = useParams()
  const dispatch = useDispatch()
  const history = useNavigate()

  const authState = useSelector(state => state.auth)
  const pvs = useSelector(state => state.pvs.pvsFormData)

  useEffect(() => {
    if (enc_pvs_entry_id) {
      dispatch(getPvsDetails({ enc_pvs_entry_id }, authState?.token))
    }
  }, [enc_pvs_entry_id])

  return (
    <div className="page-content">
      <Container fluid>
        <div className="d-flex align-items-center gap-3 mb-4 mt-4">
          <button
            className="btn btn-outline-primary btn-sm"
            onClick={() => history(-1)}
          >
            <i className="mdi mdi-arrow-left me-1"></i>Back
          </button>
          <h4 className="nom-title h4 mb-0">PVS Details</h4>
        </div>

        {!pvs ? (
          <div className="text-center py-5 text-muted">Loading...</div>
        ) : (
          <Row>
            <Col md={12}>
              {/* PVS Card Details */}
              <SectionCard
                icon="ion ion-ios-albums text-success"
                title="PVS Card Details"
              >
                <Row>
                  <Col md={6}>
                    <InfoRow label="Card Number" value={pvs.token_code} />
                    <InfoRow label="Brand Name" value={pvs.brand_name} />
                    <InfoRow label="Status" value={pvs.status_label} />
                  </Col>
                  <Col md={6}>
                    <InfoRow label="Seller Name" value={pvs.seller_name} />
                    <InfoRow label="Mobile" value={pvs.seller_contact_no} />
                    <InfoRow label="Email" value={pvs.seller_email_id} />
                  </Col>
                </Row>
              </SectionCard>

              {/* Category & Classification */}
              <SectionCard
                icon="ion ion-ios-list text-primary"
                title="Category & Classification"
              >
                <InfoRow label="Category" value={pvs.categories_label} />
                <InfoRow
                  label="Sub Categories"
                  value={pvs.subcategories_label}
                />
                <InfoRow label="Keywords" value={pvs.keywords_label} />
                <InfoRow label="Products" value={pvs.products} />
              </SectionCard>

              {/* Billing Details */}
              {pvs.billing_details && (
                <SectionCard
                  icon="ion ion-ios-card text-warning"
                  title="Billing Details"
                >
                  <Row>
                    <Col md={6}>
                      <InfoRow
                        label="Customer Type"
                        value={pvs.billing_details.customer_type}
                      />
                      <InfoRow
                        label="Name"
                        value={
                          `${pvs.billing_details.first_name || ""} ${pvs.billing_details.last_name || ""}`.trim() ||
                          null
                        }
                      />
                      <InfoRow
                        label="Mobile"
                        value={pvs.billing_details.mobile_no}
                      />
                      <InfoRow
                        label="Email"
                        value={pvs.billing_details.email_id}
                      />
                      <InfoRow
                        label="Company Name"
                        value={pvs.billing_details.company_name}
                      />
                      <InfoRow
                        label="GST Number"
                        value={pvs.billing_details.gst_number}
                      />
                    </Col>
                    <Col md={6}>
                      <InfoRow
                        label="Address"
                        value={pvs.billing_details.address}
                      />
                      <InfoRow label="City" value={pvs.billing_details.city} />
                      <InfoRow
                        label="State"
                        value={pvs.billing_details.state}
                      />
                      <InfoRow
                        label="Pincode"
                        value={pvs.billing_details.pincode}
                      />
                    </Col>
                  </Row>
                </SectionCard>
              )}
            </Col>
          </Row>
        )}
      </Container>
    </div>
  )
}

export default ViewPvsDetails
